import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { COMPANY } from '../../const/company';
import CompanyRouter from '../CompanyRouter';

import RatingView from './pages/RatingView';
import QvRatingView from './pages/qv/QvRatingView';
import DaishinRatingView from './pages/daishin/DaishinRatingView';
import HyundairsRatingView from './pages/hyundairs/HyundairsRatingView';

const COMPANY_VIEW = {
  [COMPANY.QV.id]: QvRatingView,
  [COMPANY.DAISHIN.id]: DaishinRatingView,
  [COMPANY.HYUNDAIRS.id]: HyundairsRatingView,
};

@observer
class RatingRouter extends Component {
  render() {
    return (
      <CompanyRouter
        map={COMPANY_VIEW}
        fallback={RatingView}
        {...this.props}
      />
    );
  }
}

export default RatingRouter;
